<template>
  <el-dialog
    class="modal"
    title="User Info"
    :close-on-click-modal="false"
    :visible="visible"
    @close="$emit('close', false)"
    width="1200px">
    <div class="dialog-title" slot="title">
      <i class="iconfont icon-xiazai"></i>
      {{ $t('myDownload') }}
    </div>
    <div>
      <div style="text-align: right">
        <el-tooltip :content="$t('refresh')" placement="bottom">
          <i class="el-icon-refresh f-s-20 refresh-icon" @click="refresh"></i>
        </el-tooltip>
      </div>
      <Table
        :dataSource="dataSource"
        :columns="tableColumns"
        :height='600'
      >
        <template #status>
          <el-table-column
            :label="$t('status')"
          >
            <template slot-scope="scope">
              {{ scope.row.status === 1 ? $t('inExport') : scope.row.status === 2 ? $t('success') : $t('failure') }}
            </template>
          </el-table-column>
        </template>
        <template #startTime>
          <el-table-column
            :label="$t('startTime')"
          >
            <template slot-scope="scope">
              {{ moment(scope.row.startTime * 1000).format('YYYY-MM-DD HH:mm:ss') }}
            </template>
          </el-table-column>
        </template>
        <template #endTime>
          <el-table-column
            :label="$t('endTime')"
          >
            <template slot-scope="scope">
              {{ scope.row.endTime ? moment(scope.row.endTime * 1000).format('YYYY-MM-DD HH:mm:ss') : '' }}
            </template>
          </el-table-column>
        </template>
        <template #operation>
          <el-table-column
            :label="$t('operation')"
          >
            <template slot-scope="scope">
              <!-- <el-button
                v-if="scope.row.status === 2"
                class="blue-btn"
                @click="downloadFile(scope.row)">{{ $t('download') }}
              </el-button> -->
              <el-tooltip effect="dark" :content="$t('download')" placement="top">
                <i class="iconfont el-icon-download pointer" v-if="scope.row.status === 2" @click="downloadFile(scope.row)"></i>
              </el-tooltip>
              <el-tooltip effect="dark" :content="$t('delete')" placement="top">
                <i class="iconfont iconshanchu pointer" style="margin-left: 10px" v-if="scope.row.status !== 1" @click="deleteFile(scope.row)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </template>
      </Table>
      <Pagination
        v-if="dataSource.length > 0"
        :total="total"
        :pageSize="pageSize"
        :currentPage="pageNumber"
        @change="getExportListData"
        style="margin: 10px 5% 0;"
      />
    </div>
  </el-dialog>
</template>

<script>
import { exportInfoList, importZone, deleteDownloadInfo } from '../../api/importAndExport'
import config from '../../common/config'
import moment from 'moment'
import Cookies from 'js-cookie'

export default {
  name: 'accountManagement',
  props: {},
  data () {
    return {
      visible: true,
      dataSource: [],
      total: 0,
      pageNumber: 1,
      pageSize: 10,
      state: 0,
      moment: moment,
      tableColumns: [{
        prop: 'fileName',
        label: this.$t('filename'),
        showOverflowTooltip: true
      }, {
        slotName: 'status',
        prop: 'status',
        label: this.$t('status')
      }, {
        prop: 'message',
        label: this.$t('message')
      }, {
        slotName: 'startTime',
        prop: 'startTime',
        label: this.$t('startTime')
      }, {
        slotName: 'endTime',
        prop: 'endTime',
        label: this.$t('endTime')
      }, {
        slotName: 'operation',
        label: this.$t('operation')
      }]
    }
  },
  mounted () {
    this.getExportListData()
  },
  methods: {
    // 获取账号列表
    getExportListData (pageObj = { pageNum: 1, pageSize: this.pageSize }) {
      const params = {
        pageNumber: pageObj.pageNum,
        pageSize: pageObj.pageSize,
        userId: Cookies.get(config.userId),
        type: 2,
      }
      exportInfoList(params).then(res => {
        this.dataSource = res.data
        this.total = res.total
        this.pageSize = pageObj.pageSize
        this.pageNumber = res.pageNumber
      })
    },
    // 下载文件
    downloadFile (file) {
      let url = "/en/exportInfo/downloadFile?filePath=" + encodeURIComponent(file.filePath)
      window.location.href = url
    },
    // 删除文件
    deleteFile (data) {
      this.$msgbox({
        title: this.$t('prompt'),
        message: this.$t('sureDelete'),
        showCancelButton: true,
        confirmButtonText: this.$t('sure'),
        cancelButtonText: this.$t('cancel'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            // instance.confirmButtonText = '执行中...'
            deleteDownloadInfo({
              id: data.id
            }).then(res => {
              instance.confirmButtonLoading = false
              this.getExportListData()
              done()
            })
          } else {
            done()
          }
        }
      }).then(action => {
      })
    },
    refresh () {
      this.getExportListData()
    }
  }
}
</script>

<style lang="less" scoped>
.refresh-icon {
  // color: @color-blue;
  position: relative;
  left: -4px;
}
</style>
